export const initArticleLightbox = () =>
{
    const article = document.querySelector("article");

    if (!article)
    {
        return;
    }

    const lightbox = document.createElement("div");
    const lightboxImage = document.createElement("img");
    let previousActiveElement: Element | null = null;

    lightbox.className = "article-lightbox";
    lightbox.setAttribute("role", "dialog");
    lightbox.setAttribute("aria-modal", "true");
    lightbox.setAttribute("aria-label", "Expanded article image");
    lightbox.tabIndex = -1;
    lightbox.hidden = true;

    lightboxImage.alt = "";
    lightbox.appendChild(lightboxImage);
    document.body.appendChild(lightbox);

    const closeLightbox = () =>
    {
        lightbox.hidden = true;
        document.body.classList.remove("lightbox-open");
        lightboxImage.removeAttribute("src");
        lightboxImage.removeAttribute("srcset");

        if (previousActiveElement instanceof HTMLElement)
        {
            previousActiveElement.focus();
        }
    };

    article.addEventListener("click", event =>
    {
        const target = event.target;

        if (!(target instanceof HTMLImageElement))
        {
            return;
        }

        event.preventDefault();
        previousActiveElement = document.activeElement;
        const linkedImage = target.closest("a[href]");
        const lightboxSource = linkedImage instanceof HTMLAnchorElement ? linkedImage.href : (target.currentSrc || target.src);

        lightboxImage.src = lightboxSource;
        lightboxImage.alt = target.alt;

        if (linkedImage instanceof HTMLAnchorElement)
        {
            lightboxImage.removeAttribute("srcset");
        }
        else if (target.srcset)
        {
            lightboxImage.srcset = target.srcset;
        }
        else
        {
            lightboxImage.removeAttribute("srcset");
        }

        lightbox.hidden = false;
        document.body.classList.add("lightbox-open");
        lightbox.focus();
    });

    lightbox.addEventListener("click", () =>
    {
        closeLightbox();
    });

    document.addEventListener("keydown", event =>
    {
        if (event.key === "Escape" && !lightbox.hidden)
        {
            closeLightbox();
        }
    });
};
